import { closeModal } from 'actions/modal';
import { Button, BUTTON_TYPE_BLUE, BUTTON_TYPE_WHITE } from 'components/Buttons/Button';

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { Modal } from '../../containers';
import Strings from '../../Strings';
import styles from './style.module.scss';

class NewConfirmationModal extends PureComponent {
  static MODAL_NAME = 'new-confirmation-modal';

  static propTypes = {
    onOpen: PropTypes.func,
    onCancel: PropTypes.func,
    caption: PropTypes.string,
    data: PropTypes.shape({
      title: PropTypes.string,
      centered: PropTypes.bool,
      cancelText: PropTypes.string,
      confirmText: PropTypes.string,
      onCancel: PropTypes.func,
      onConfirm: PropTypes.func,
      noCloseAfterConfirm: PropTypes.bool,
      afterClose: PropTypes.func,
      afterOpen: PropTypes.func,
      isSubmitButtonDisabled: PropTypes.bool,
      submitButtonType: PropTypes.number,
    }),
  };

  state = {
    isSubmitButtonDisabled:
      typeof this.props.data.isSubmitButtonDisabled !== 'undefined' ? this.props.data.isSubmitButtonDisabled : false,
    isConfirming: false,
  };

  // When `onConfirm` returns a promise, the modal stays open with its buttons disabled until it
  // settles. The page underneath stays blocked while the write is in flight, so nobody (user or
  // test) can navigate to data that doesn't include it yet.
  onConfirm = async () => {
    const { data } = this.props;
    const { isConfirming } = this.state;
    if (isConfirming) {
      return;
    }
    this.setState({ isConfirming: true });
    try {
      await data.onConfirm?.();
    } finally {
      this.setState({ isConfirming: false });
      if (!data.noCloseAfterConfirm) {
        this.getCancelFunction()();
      }
    }
  };

  componentDidMount() {
    const { data } = this.props;
    if (typeof data.afterOpen === 'function') {
      data.afterOpen(this);
    }
  }

  getCancelFunction = () => {
    const { onCancel, data } = this.props;
    return data.onCancel ?? onCancel;
  };

  render() {
    const { onOpen, caption, data, children, ...props } = this.props;
    const { isSubmitButtonDisabled, isConfirming } = this.state;

    const onCancel = this.getCancelFunction();

    return (
      <Modal onOpen={onOpen} name={NewConfirmationModal.MODAL_NAME} withoutContainer {...props}>
        <div className={styles.newModal}>
          <header>{data.title ? data.title : caption}</header>
          <section>
            <div className={styles.text}>{children ?? data.text}</div>

            <div className={styles.buttons}>
              <Button buttonType={BUTTON_TYPE_WHITE} onClick={onCancel} disabled={isConfirming}>
                {data.cancelText ? data.cancelText : Strings.cancel}
              </Button>
              <Button
                buttonType={data.submitButtonType ?? BUTTON_TYPE_BLUE}
                onClick={this.onConfirm}
                disabled={isSubmitButtonDisabled || isConfirming}
              >
                {data.confirmText ? data.confirmText : Strings.confirm}
              </Button>
            </div>
          </section>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({ onCancel: () => dispatch(closeModal(NewConfirmationModal.MODAL_NAME)) });

export default connect(null, mapDispatchToProps)(NewConfirmationModal);
